import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { showError } from '@store/logged/actions';
import { errorResponsive } from '@constants/errorObjects';
import { MSJ_ERROR_EMAIL_AGE } from '@constants/email';

const useEmailAge = (prevErrorEmailAge = false) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isEmailAgeInvalid, setIsEmailAgeInvalid] = useState(prevErrorEmailAge);

  const showErrorSnackBar = () => dispatch(showError({ message: t('errors.email.emailAge') }));

  const isErrorEmailAge = (error) => {
    if (error.message === MSJ_ERROR_EMAIL_AGE) {
      setIsEmailAgeInvalid(true);
      showErrorSnackBar();
      return true;
    }
    dispatch(showError(errorResponsive(error)));
    return false;
  };

  return {
    isEmailAgeInvalid,
    setIsEmailAgeInvalid,
    isErrorEmailAge,
    showErrorSnackBar,
  };
};

export default useEmailAge;
